import { Pipe, PipeTransform } from '@angular/core';

export function formatNumber(value: number | string | null | undefined, decimals: number = 2, locale: string = 'de-DE'): string {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  const numValue = typeof value === 'string' ? Number.parseFloat(value) : value;

  if (Number.isNaN(numValue)) {
    return '';
  }

  return numValue.toLocaleString(locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
}

@Pipe({
  name: 'customNumber',
  standalone: true
})
export class CustomNumberPipe implements PipeTransform {

  transform(value: number | string | null | undefined, decimals: number = 2, locale: string = 'de-DE'): string {
    return formatNumber(value, decimals, locale);
  }
}
